export default {
    "data": {
        "h5": {
            "titleImg": [
                "https://s21.lgstatic.com/growth/activity/20210421/1618970858720.png",
                "https://s21.lgstatic.com/growth/activity/20210421/1618971755309.png",
                "https://s20.lgstatic.com/growth/activity/20210805/1628134786647.png",
                "https://s21.lgstatic.com/growth/activity/20210805/1628134799608.png",
                "https://s20.lgstatic.com/growth/activity/20210805/1628135193820.png"
            ],
            "swiperList1": [
                "https://s21.lgstatic.com/growth/activity/20210425/1619333387979.png",
                "https://s21.lgstatic.com/growth/activity/20210425/1619333396659.png",
                "https://s21.lgstatic.com/growth/activity/20210425/1619333404074.png"
            ],
            "swiperList2": [
                "https://s21.lgstatic.com/growth/activity/20210420/1618903834469.png",
                "https://s21.lgstatic.com/growth/activity/20210420/1618903843696.png",
                "https://s21.lgstatic.com/growth/activity/20210420/1618903851617.png",
                "https://s21.lgstatic.com/growth/activity/20210420/1618903859237.png"
            ],
            "swiperList3": [
                "https://s21.lgstatic.com/growth/activity/20210420/1618903952671.png",
                "https://s21.lgstatic.com/growth/activity/20210420/1618903960934.png"
            ],
            "imgList": [
                "https://s20.lgstatic.com/growth/activity/20220316/1647399677596.png",
                "https://s21.lgstatic.com/growth/activity/20220318/1647588417733.png",

                "https://s21.lgstatic.com/growth/activity/20210805/1628133640861.png",

                "https://s21.lgstatic.com/growth/activity/20210420/1618910326930.png",
                "https://s20.lgstatic.com/growth/activity/20210805/1628135215626.png",
                // "https://s21.lgstatic.com/growth/activity/20210805/1628135223872.png",

                // "https://s20.lgstatic.com/growth/activity/20220316/1647399751975.png"
            ],
            "btnimgList": {
                "footer": "https://s20.lgstatic.com/growth/activity/20210826/1629970791619.png?x-oss-process=style/80",
                "footerB": "https://s21.lgstatic.com/growth/activity/20210826/1629978168182.png?x-oss-process=style/80",
                "receive": "https://s21.lgstatic.com/growth/activity/20210420/1618902073777.png",
                "getMore": "https://s21.lgstatic.com/growth/activity/20210420/1618906109957.png"
            },
            "tabMain": {
                "stageList": [
                    {
                        "stage": "第一阶段",
                        "title": "运维基本功",
                        "external": {
                            "phaseTargetList": [
                                "能独立安装centos7系统环境，并学会使用 centos7系统基本操作。",
                                "熟练掌握打包、压缩等各项日常工作操作。",
                                "熟练掌握centos7系统 的用户及用户组的各项配置工作。",
                                "......"
                            ],
                            "skillsList": [
                                "Linux操作系统概述",
                                "安装 VMWare",
                                "配置VMWare 内容",
                                "配置虚拟机网络",
                                "安装centos7.8",
                                "VMWare快照、克隆",
                                "XShell使用",
                                "......"
                            ],
                        },
                        "inside": {
                            "phaseTargetList": [
                                "能独立安装centos7系统环境，并学会使用 centos7系统基本操作。",
                                "熟练掌握打包、压缩等各项日常工作操作。",
                                "熟练掌握centos7系统 的用户及用户组的各项配置工作。",
                                "熟练掌握yum、rpm等方式进行软件安装，满足日常工作要求。",
                                "熟练使用centos7系统 中各种配置参数、高级指令。",
                                "掌握shell基础知识，能够使用变量、 字符串、运算符、流程控制、循环、函数等技能。"
                            ],
                            "skillsList": [
                                "Linux操作系统概述",
                                "安装 VMWare",
                                "配置VMWare 内容",
                                "配置虚拟机网络",
                                "安装centos7.8",
                                "VMWare快照、克隆 ",
                                "XShell使用",
                                "常用命令",
                                "centos7系统概述、目录介绍 ",
                                "目录管理",
                                "文件管理",
                                "文件打包与压缩",
                                "文件处理命令",
                                "用户和组概述 ",
                                "用户组管理 ",
                                "用户管理",
                                "切换用户",
                                "权限管理概述 ",
                                "Linux权限类别 ",
                                "普通权限设置 ",
                                "高级权限",
                                "源码、yum和 rpm安装",
                                "top、free、df、ps、netstat、kill与killall命令",
                                "shell概述、语法规则、变量 ",
                                "流程控制",
                                "数组",
                                "函数",
                                "正则表达式"
                            ],
                        }

                    }, {
                        "stage": "第二阶段",
                        "title": "Linux高级使用篇",
                        "external": {
                            "phaseTargetList": [
                                "掌握vi/vim的实战应用。",
                                "可以自由选择使用文本三 剑客或现代文本处理工具进行日常工作。",
                                "熟练搭建企业 文件、图片共享系统。",
                                "......"
                            ],
                            "skillsList": [
                                "vim",
                                "现代文本编辑器",
                                "editplus使用技巧",
                                "命令格式介绍",
                                "正则表达式回顾",
                                "grep命令介绍和实战",
                                "通配符实战",
                                "......"
                            ],
                        },
                        "inside": {
                            "phaseTargetList": [
                                "掌握vi/vim的实战应用。",
                                "可以自由选择使用文本三 剑客或现代文本处理工具进行日常工作。",
                                "熟练搭建企业 文件、图片共享系统。",
                                "了解网络管理的各项基础概念。",
                                "熟练配置服务器的磁盘。",
                                "能够熟练搭建出企业级服务器基础环境。",
                                "理解企业中为什么需要跳板机，并了解企业 级项目对安全性的重视。",
                                "熟练搭建企业级共享文件系统。"
                            ],
                            "skillsList": [
                                "vim",
                                "现代文本编辑器",
                                "editplus使用技巧",
                                "命令格式介绍",
                                "正则表达式回顾",
                                "grep命令介绍和实战",
                                "通配符实战",
                                "正则表达式实战",
                                "sed命令介绍和实战",
                                "awk命令介绍和实战",
                                "grep awk sed对比",
                                "高级指令",
                                "NFS服务",
                                "网络管理",
                                "VPN概述",
                                "OpenVPN实战",
                                "LVM",
                                "raid基础概念详解",
                                "系统优化",
                                "使用阿里云镜像源 ",
                                "服务器优化",
                                "升级系统内核",
                                "scp指令详解",
                                "免密登录原理",
                                "免密登录实战",
                                "跳板机理论",
                                "文件共享系统",
                                "rsync高级实战"
                            ],
                        }
                    }, {
                        "stage": "第三阶段",
                        "title": "服务篇",
                        "external": {
                            "phaseTargetList": [
                                "能够熟练配置前端项目负载均衡及反向代理。",
                                "能够熟练配置PHP语言的开发环境",
                                "独立完成Java语言的各种环境安装及配置。",
                                "......"
                            ],
                            "skillsList": [
                                "Nginx",
                                "LVS",
                                "Squid",
                                "Haproxy",
                                "Keepalive",
                                "PHP概述",
                                "PHP安装和配置",
                                "......"
                            ],
                        },
                        "inside": {
                            "phaseTargetList": [
                                "能够熟练配置前端项目负载均衡及反向代理。",
                                "能够熟练配置PHP语言的开发环境。",
                                "独立完成Java语言的各种环境安装及配置。",
                                "能够熟练搭建 Maven私服仓库并掌握Maven各种环境 安装及配置。",
                                "熟练配置开发环境、运维环境的版本控制安装、配置。",
                                "熟练配置开发环境、运维环境的MYSQL数据库的安装及配置，并掌握MYSQL 数据的各项知识。",
                                "熟练配置开发环境、运维环境的Redis安装及配置，并掌握Redis的基础技能。",
                                "熟练搭建ZK、Kafka在运维环境的安装及各项配置。",
                                "熟练搭建企业内网域名服务器。",
                                "熟练安装、配置企业级内网yum源 服务器。"
                            ],
                            "skillsList": [
                                "Nginx",
                                "LVS",
                                "Squid",
                                "Haproxy ",
                                "Keepalive",
                                "PHP概述 ",
                                "PHP安装和配置",
                                "Java概述",
                                "JDK安装和配置",
                                "IDEA安装、常用配置",
                                "Maven概述、安装和配置",
                                "Maven常用命令 ",
                                "Maven项目打包 ",
                                "Maven项目部署",
                                "Git概述、安装和配置",
                                "Git常用命令",
                                "Git操作Maven项目",
                                "Gitlab安装、注册、配置 ",
                                "Gitlab常规操作",
                                "MySQL概述、安装和配置",
                                "MySQL基本操作",
                                "SQL语句详解",
                                "MySQL备份与还原 ",
                                "MySQL高可用",
                                "Redis概述和安装",
                                "Redis数据类型 ",
                                "Redis集群",
                                "ZK概述、集群搭建及日常使用",
                                "Kafka概述、日常使用和集群搭建",
                                "DNS简介、解析类型和架构",
                                "智能DNS服务 ",
                                "rpm包制作概述 ",
                                "yum仓库搭建"
                            ],
                        }
                    }, {
                        "stage": "第四阶段",
                        "title": "企业实战架构篇",
                        "external": {
                            "phaseTargetList": [
                                "熟练搭建企业内部的博客系统。",
                                "结合日志分析系统让学员熟练 掌握ELK的企业级应用。",
                                "熟练搭建监控 系统并完成日常工作。",
                                "......"
                            ],
                            "skillsList": [
                                "LNMP架构",
                                "创建免费证书",
                                "LNMP实战",
                                "ELK概述",
                                "ELK日志架构",
                                "Filebeat详解",
                                "Logstash日志解析",
                                "......"
                            ],
                        },
                        "inside": {
                            "phaseTargetList": [
                                "熟练搭建企业内部的博客系统。",
                                "结合日志分析系统让学员熟练 掌握ELK的企业级应用。",
                                "熟练搭建监控 系统并完成日常工作。",
                                "熟练搭建 大规模的集群。",
                                "熟 练配置FastDFS的各项参数。满足企业 级环境需求。"
                            ],
                            "skillsList": [
                                "LNMP架构 ",
                                "创建免费证书",
                                "LNMP实战",
                                "ELK概述",
                                "ELK日志架构",
                                "Filebeat详解",
                                "Logstash日志解析",
                                "Elasticsearch集群搭建",
                                "Kibana日志展示",
                                "MYSQL慢查询日志收集展示 ",
                                "Nginx日志收集展示",
                                "监控概述",
                                "监控系统对比 ",
                                "Zabbix概述",
                                "Zabbix架构",
                                "Zabbix集群安装 ",
                                "Zabbix使用",
                                "Ansible概述",
                                "Ansible使用",
                                "Ansible使用实战",
                                "FastDFS快速实战 ",
                                "FastDFS核心原理 ",
                                "FastDFS运维管理"
                            ],
                        }
                    }, {
                        "stage": "第五阶段",
                        "title": "Linux云计算",
                        "external": {
                            "phaseTargetList": [
                                "了解容器 化技术的前世今生。并为后期学习K8S 集群技术打下良好基础。",
                                "理解CI/CD和DevOps等各项 运维-开发的应用",
                                "熟练搭建 K8S集群的安装及配置。并掌握K8S集 群的各项技能。",
                                "......"
                            ],
                            "skillsList": [
                                "Docker 快速实战",
                                "Docker 核心原理",
                                "Docker 运维管理",
                                "CI/CD、DevOps概述",
                                "Jenkins概述与安装",
                                "Jenkins环境搭建",
                                "Jenkins项目实战",
                                "......"
                            ],
                        },
                        "inside": {
                            "phaseTargetList": [
                                "了解容器 化技术的前世今生。并为后期学习K8S 集群技术打下良好基础。",
                                "理解CI/CD和DevOps等各项 运维-开发的应用",
                                "熟练搭建 K8S集群的安装及配置。并掌握K8S集 群的各项技能。",
                                "理解容器化技术在企业中的应用"
                            ],
                            "skillsList": [
                                "Docker 快速实战",
                                "Docker 核心原理",
                                "Docker 运维管理",
                                "CI/CD、DevOps概述",
                                "Jenkins概述与安装 ",
                                "Jenkins环境搭建",
                                "Jenkins项目实战",
                                "Jenkins运维管理",
                                "Kubernetes 快速实战",
                                "Kubernetes 核心原理",
                                "Kubernetes 运维管理",
                                "项目架构设计分析",
                                "分阶段容器化部署项目",
                                "部署利器Rancher2",
                                "Prometheus监控系统实战"
                            ],
                        }
                    }
                ]
            }
        },
        "pc": {
            "pcSwiperList1": [
                "https://s21.lgstatic.com/growth/activity/20210425/1619333522449.png",
                "https://s21.lgstatic.com/growth/activity/20210425/1619333537987.png",
                "https://s21.lgstatic.com/growth/activity/20210425/1619333545285.png"
            ],
            "pcSwiperList2": [
                "https://s21.lgstatic.com/growth/activity/20210425/1619333718104.png",
                "https://s21.lgstatic.com/growth/activity/20210425/1619333727227.png",
                "https://s21.lgstatic.com/growth/activity/20210422/1619085067049.png",
                "https://s21.lgstatic.com/growth/activity/20210422/1619085074586.png"
            ],
            "imgList": [
                "https://s20.lgstatic.com/growth/activity/20220318/1647588466867.png",

                "https://s21.lgstatic.com/growth/activity/20210805/1628146845522.png",

                "https://s21.lgstatic.com/growth/activity/20210423/1619149654522.png",

                "https://s20.lgstatic.com/growth/activity/20211126/1637918416404.jpg?x-oss-process=style/80",
                // "https://s20.lgstatic.com/growth/activity/20210805/1628147507170.png",
                "https://s20.lgstatic.com/growth/activity/20220316/1647399879917.png"
            ],
            "titleImgList": [
                "https://s21.lgstatic.com/growth/activity/20210422/1619084456203.png",
                "https://s21.lgstatic.com/growth/activity/20210805/1628146862753.png",
                "https://s21.lgstatic.com/growth/activity/20210805/1628147155715.png",
                "https://s20.lgstatic.com/growth/activity/20210805/1628147147059.png",
                "https://s21.lgstatic.com/growth/activity/20210422/1619085539537.png"
            ],
            "btnImgList": {
                "footer": "https://s21.lgstatic.com/growth/activity/20210422/1619085531180.png",
                "footerB": "https://s21.lgstatic.com/growth/activity/20210422/1619085531180.png",
                "more": "https://s21.lgstatic.com/growth/activity/20210422/1619085754690.png",
            },
            "tabMain": {
                "stageList": [
                    {
                        "stage": "第一阶段",
                        "title": "运维基本功",
                        "external": {
                            "phaseTargetList": [
                                "能独立安装centos7系统环境，并学会使用 centos7系统基本操作。",
                                "熟练掌握打包、压缩等各项日常工作操作。",
                                "熟练掌握centos7系统 的用户及用户组的各项配置工作。",
                                "熟练掌握yum、rpm等方式进行软件安装，满足日常工作要求。",
                                "熟练使用centos7系统 中各种配置参数、高级指令。",
                                "掌握shell基础知识，能够使用变量、 字符串、运算符、流程控制、循环、函数等技能。"
                            ],
                            "skillsList": [
                                "Linux操作系统概述",
                                "安装 VMWare",
                                "配置VMWare 内容",
                                "配置虚拟机网络",
                                "安装centos7.8",
                                "VMWare快照、克隆",
                                "XShell使用",
                                "......"
                            ],
                        },
                        "inside": {
                            "phaseTargetList": [
                                "能独立安装centos7系统环境，并学会使用 centos7系统基本操作。",
                                "熟练掌握打包、压缩等各项日常工作操作。",
                                "熟练掌握centos7系统 的用户及用户组的各项配置工作。",
                                "熟练掌握yum、rpm等方式进行软件安装，满足日常工作要求。",
                                "熟练使用centos7系统 中各种配置参数、高级指令。",
                                "掌握shell基础知识，能够使用变量、 字符串、运算符、流程控制、循环、函数等技能。"
                            ],
                            "skillsList": [
                                "Linux操作系统概述",
                                "安装 VMWare",
                                "配置VMWare 内容",
                                "配置虚拟机网络",
                                "安装centos7.8",
                                "VMWare快照、克隆 ",
                                "XShell使用",
                                "常用命令",
                                "centos7系统概述、目录介绍 ",
                                "目录管理",
                                "文件管理",
                                "文件打包与压缩",
                                "文件处理命令",
                                "用户和组概述 ",
                                "用户组管理 ",
                                "用户管理",
                                "切换用户",
                                "权限管理概述 ",
                                "Linux权限类别 ",
                                "普通权限设置 ",
                                "高级权限",
                                "源码、yum和 rpm安装",
                                "top、free、df、ps、netstat、kill与killall命令",
                                "shell概述、语法规则、变量 ",
                                "流程控制",
                                "数组",
                                "函数",
                                "正则表达式"
                            ],
                        }

                    }, {
                        "stage": "第二阶段",
                        "title": "Linux高级使用篇",
                        "external": {
                            "phaseTargetList": [
                                "掌握vi/vim的实战应用。",
                                "可以自由选择使用文本三 剑客或现代文本处理工具进行日常工作。",
                                "熟练搭建企业 文件、图片共享系统。",
                                "了解网络管理的各项基础概念。",
                                "熟练配置服务器的磁盘。",
                                "能够熟练搭建出企业级服务器基础环境。",
                            ],
                            "skillsList": [
                                "vim",
                                "现代文本编辑器",
                                "editplus使用技巧",
                                "命令格式介绍",
                                "正则表达式回顾",
                                "grep命令介绍和实战",
                                "通配符实战",
                                "......"
                            ],
                        },
                        "inside": {
                            "phaseTargetList": [
                                "掌握vi/vim的实战应用。",
                                "可以自由选择使用文本三 剑客或现代文本处理工具进行日常工作。",
                                "熟练搭建企业 文件、图片共享系统。",
                                "了解网络管理的各项基础概念。",
                                "熟练配置服务器的磁盘。",
                                "能够熟练搭建出企业级服务器基础环境。",
                                "理解企业中为什么需要跳板机，并了解企业 级项目对安全性的重视。",
                                "熟练搭建企业级共享文件系统。"
                            ],
                            "skillsList": [
                                "vim",
                                "现代文本编辑器",
                                "editplus使用技巧",
                                "命令格式介绍",
                                "正则表达式回顾",
                                "grep命令介绍和实战",
                                "通配符实战",
                                "正则表达式实战",
                                "sed命令介绍和实战",
                                "awk命令介绍和实战",
                                "grep awk sed对比",
                                "高级指令",
                                "NFS服务",
                                "网络管理",
                                "VPN概述",
                                "OpenVPN实战",
                                "LVM",
                                "raid基础概念详解",
                                "系统优化",
                                "使用阿里云镜像源 ",
                                "服务器优化",
                                "升级系统内核",
                                "scp指令详解",
                                "免密登录原理",
                                "免密登录实战",
                                "跳板机理论",
                                "文件共享系统",
                                "rsync高级实战"
                            ],
                        }
                    }, {
                        "stage": "第三阶段",
                        "title": "服务篇",
                        "external": {
                            "phaseTargetList": [
                                "能够熟练配置前端项目负载均衡及反向代理。",
                                "能够熟练配置PHP语言的开发环境。",
                                "独立完成Java语言的各种环境安装及配置。",
                                "能够熟练搭建 Maven私服仓库并掌握Maven各种环境 安装及配置。",
                                "熟练配置开发环境、运维环境的版本控制安装、配置。",
                                "熟练配置开发环境、运维环境的MYSQL数据库的安装及配置，并掌握MYSQL 数据的各项知识。",
                            ],
                            "skillsList": [
                                "Nginx",
                                "LVS",
                                "Squid",
                                "Haproxy",
                                "Keepalive",
                                "PHP概述",
                                "PHP安装和配置",
                                "......"
                            ],
                        },
                        "inside": {
                            "phaseTargetList": [
                                "能够熟练配置前端项目负载均衡及反向代理。",
                                "能够熟练配置PHP语言的开发环境。",
                                "独立完成Java语言的各种环境安装及配置。",
                                "能够熟练搭建 Maven私服仓库并掌握Maven各种环境 安装及配置。",
                                "熟练配置开发环境、运维环境的版本控制安装、配置。",
                                "熟练配置开发环境、运维环境的MYSQL数据库的安装及配置，并掌握MYSQL 数据的各项知识。",
                                "熟练配置开发环境、运维环境的Redis安装及配置，并掌握Redis的基础技能。",
                                "熟练搭建ZK、Kafka在运维环境的安装及各项配置。",
                                "熟练搭建企业内网域名服务器。",
                                "熟练安装、配置企业级内网yum源 服务器。"
                            ],
                            "skillsList": [
                                "Nginx",
                                "LVS",
                                "Squid",
                                "Haproxy ",
                                "Keepalive",
                                "PHP概述 ",
                                "PHP安装和配置",
                                "Java概述",
                                "JDK安装和配置",
                                "IDEA安装、常用配置",
                                "Maven概述、安装和配置",
                                "Maven常用命令 ",
                                "Maven项目打包 ",
                                "Maven项目部署",
                                "Git概述、安装和配置",
                                "Git常用命令",
                                "Git操作Maven项目",
                                "Gitlab安装、注册、配置 ",
                                "Gitlab常规操作",
                                "MySQL概述、安装和配置",
                                "MySQL基本操作",
                                "SQL语句详解",
                                "MySQL备份与还原 ",
                                "MySQL高可用",
                                "Redis概述和安装",
                                "Redis数据类型 ",
                                "Redis集群",
                                "ZK概述、集群搭建及日常使用",
                                "Kafka概述、日常使用和集群搭建",
                                "DNS简介、解析类型和架构",
                                "智能DNS服务 ",
                                "rpm包制作概述 ",
                                "yum仓库搭建"
                            ],
                        }
                    }, {
                        "stage": "第四阶段",
                        "title": "企业实战架构篇",
                        "external": {
                            "phaseTargetList": [
                                "熟练搭建企业内部的博客系统。",
                                "结合日志分析系统让学员熟练 掌握ELK的企业级应用。",
                                "熟练搭建监控 系统并完成日常工作。",
                                "熟练搭建 大规模的集群。",
                                "熟 练配置FastDFS的各项参数。满足企业 级环境需求。"
                            ],
                            "skillsList": [
                                "LNMP架构",
                                "创建免费证书",
                                "LNMP实战",
                                "ELK概述",
                                "ELK日志架构",
                                "Filebeat详解",
                                "Logstash日志解析",
                                "......"
                            ],
                        },
                        "inside": {
                            "phaseTargetList": [
                                "熟练搭建企业内部的博客系统。",
                                "结合日志分析系统让学员熟练 掌握ELK的企业级应用。",
                                "熟练搭建监控 系统并完成日常工作。",
                                "熟练搭建 大规模的集群。",
                                "熟 练配置FastDFS的各项参数。满足企业 级环境需求。"
                            ],
                            "skillsList": [
                                "LNMP架构 ",
                                "创建免费证书",
                                "LNMP实战",
                                "ELK概述",
                                "ELK日志架构",
                                "Filebeat详解",
                                "Logstash日志解析",
                                "Elasticsearch集群搭建",
                                "Kibana日志展示",
                                "MYSQL慢查询日志收集展示 ",
                                "Nginx日志收集展示",
                                "监控概述",
                                "监控系统对比 ",
                                "Zabbix概述",
                                "Zabbix架构",
                                "Zabbix集群安装 ",
                                "Zabbix使用",
                                "Ansible概述",
                                "Ansible使用",
                                "Ansible使用实战",
                                "FastDFS快速实战 ",
                                "FastDFS核心原理 ",
                                "FastDFS运维管理"
                            ],
                        }
                    }, {
                        "stage": "第五阶段",
                        "title": "Linux云计算",
                        "external": {
                            "phaseTargetList": [
                                "了解容器 化技术的前世今生。并为后期学习K8S 集群技术打下良好基础。",
                                "理解CI/CD和DevOps等各项 运维-开发的应用",
                                "熟练搭建 K8S集群的安装及配置。并掌握K8S集 群的各项技能。",
                                "理解容器化技术在企业中的应用"
                            ],
                            "skillsList": [
                                "Docker 快速实战",
                                "Docker 核心原理",
                                "Docker 运维管理",
                                "CI/CD、DevOps概述",
                                "Jenkins概述与安装",
                                "Jenkins环境搭建",
                                "Jenkins项目实战",
                                "......"
                            ],
                        },
                        "inside": {
                            "phaseTargetList": [
                                "了解容器 化技术的前世今生。并为后期学习K8S 集群技术打下良好基础。",
                                "理解CI/CD和DevOps等各项 运维-开发的应用",
                                "熟练搭建 K8S集群的安装及配置。并掌握K8S集 群的各项技能。",
                                "理解容器化技术在企业中的应用"
                            ],
                            "skillsList": [
                                "Docker 快速实战",
                                "Docker 核心原理",
                                "Docker 运维管理",
                                "CI/CD、DevOps概述",
                                "Jenkins概述与安装 ",
                                "Jenkins环境搭建",
                                "Jenkins项目实战",
                                "Jenkins运维管理",
                                "Kubernetes 快速实战",
                                "Kubernetes 核心原理",
                                "Kubernetes 运维管理",
                                "项目架构设计分析",
                                "分阶段容器化部署项目",
                                "部署利器Rancher2",
                                "Prometheus监控系统实战"
                            ],
                        }
                    }
                ]
            }
        },
    }
}